import { InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

export const getCache = () =>
    new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    folders: relayStylePagination(['where']),
                    models: relayStylePagination(['where', 'orderBy']),
                    assetTypes: relayStylePagination(['where', 'orderBy']),
                    manufacturers: relayStylePagination(['where']),
                    scanners: relayStylePagination(['where', 'orderBy']),
                    assets: relayStylePagination(['where', 'orderBy']),
                    directories: relayStylePagination(['where', 'orderBy']),
                    accounts: relayStylePagination(['where']),
                    assetHistories: relayStylePagination(['id']),
                    importLogs: relayStylePagination(['where', 'orderBy']),
                    importLogEntries: relayStylePagination(['where', 'orderBy']),
                    groups: relayStylePagination(['where', 'orderBy'])
                }
            },
            AssetClassGraph: { keyFields: ['assetClass'] },
            AssetFieldRolePermissionGraph: { keyFields: ['assetFieldId', 'roleId'] },
            UserDefinedFieldRolePermissionGraph: { keyFields: ['userDefinedFieldId', 'roleId'] }
        }
    });
